// extracted by mini-css-extract-plugin
module.exports = {"InputCheck":"styles_InputCheck__1S-ow"};